import { HTMLAttributes } from "react"
import styled from "styled-components"

const Address = styled.div`
  /* width: 200px; */
  padding: 0 5px;
  margin: auto;
`
const CenterParagraph = styled.p`
  text-align: center;
`
const AddressBoxStyles: React.CSSProperties = {
  backgroundColor: "#f0f0f0",
  maxWidth:'30em', 
  margin:'auto',
  borderRadius: "7px",
  borderStyle: "solid",
  borderColor: "#f0f0f0",
}
export const DeliveryAddress = (props:HTMLAttributes<HTMLDivElement>): JSX.Element => {
  return (
    <div {...props} >
      <div style={{ color: "gray", fontStyle: "italic", marginBottom: "1em" }}>
        Please send samples to:
      </div>
      <div style={{width:'100%'}}>
        <div style={AddressBoxStyles}>
          <Address>
            <CenterParagraph>
              <b>Pananosis Laboratories</b>
            </CenterParagraph>
            <CenterParagraph>17 Briden St</CenterParagraph>
            <CenterParagraph>Worcester Massachusetts</CenterParagraph>
            <CenterParagraph>01605</CenterParagraph>
          </Address>
        </div>
      </div>
    </div>
  )
}
